var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { minWidthMedia } from "@irati/ui/src/global/media";
import padding from "@irati/ui/src/global/padding";
export default styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  padding: 0 5px;\n\n  ", "\n"], ["\n  position: relative;\n  padding: 0 5px;\n\n  ",
    "\n"])), minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0 ", ";\n  "], ["\n    padding: 0 ", ";\n  "])), padding.tiny));
var templateObject_1, templateObject_2;
